var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6406 11.1992C50.0458 11.5391 60.8086 22.5129 60.8086 36L60.7998 36.6406C60.4599 50.0457 49.487 60.8085 36 60.8086L35.3594 60.7998C22.167 60.4655 11.5337 49.833 11.1992 36.6406L11.1914 36C11.1914 22.2987 22.2987 11.1914 36 11.1914L36.6406 11.1992ZM36 13.1914C23.4032 13.1914 13.1914 23.4032 13.1914 36C13.1915 48.5967 23.4033 58.8086 36 58.8086C48.5966 58.8085 58.8085 48.5966 58.8086 36C58.8086 23.4033 48.5967 13.1915 36 13.1914Z",
    fill: "#64B5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.75 25.5H33.7504C33.3362 25.5 33.0004 25.8358 33.0004 26.25V33.945L26.0332 36C25.7052 36.099 25.4861 36.4077 25.5007 36.75V45.75C25.5007 46.1642 25.8365 46.5 26.2507 46.5H45.75C46.1642 46.5 46.5 46.1642 46.5 45.75V26.25C46.5 25.8358 46.1642 25.5 45.75 25.5ZM27.0006 37.305L33.0004 35.505V45H27.0006V37.305ZM34.5004 45H45V27H34.5004V45ZM38.2503 30.75H36.7503V29.25H38.2503V30.75ZM41.2502 30.75H42.7501V29.25H41.2502V30.75ZM38.2503 34.5H36.7503V33H38.2503V34.5ZM41.2502 34.5H42.7501V33H41.2502V34.5ZM38.2503 38.25H36.7503V36.75H38.2503V38.25ZM41.2502 38.25H42.7501V36.75H41.2502V38.25ZM38.2503 42H36.7503V40.5H38.2503V42ZM30.7505 38.25H29.2506V39.75H30.7505V38.25ZM29.2506 42H30.7505V43.5H29.2506V42ZM41.2502 42H42.7501V40.5H41.2502V42Z",
    fill: "#001E79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingIcon);
export default __webpack_public_path__ + "static/media/buildingIcon.017ff1065a9185b4459ffe9798587e0e.svg";
export { ForwardRef as ReactComponent };